import { BaseRouteService } from "core/services";

class FacilityInventoryCountDetailRouteService extends BaseRouteService {
	constructor() {
		super("facility-inventory-count-details");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityInventoryCountHeaderId}`, filter);
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

	download(filter) {
        return super.find(this.base + '/download/{?searchQuery,sort,facilityOrderId}', filter);    
    }

	update(resource) {
		return super.update(`${this.base}/{id}`, resource);	
	}
	
	delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

	getExisting(facilityInventoryCountHeaderId, productId){
        return super.get(this.base + '/existing/{facilityInventoryCountHeaderId}/{productId}', null, {
            facilityInventoryCountHeaderId: facilityInventoryCountHeaderId,
            productId: productId
        })
    }

	createFacilityInventoryCountDetails(resource){
		return super.create(`${this.base}/create-facility-inventory-count-details`, resource);	
    }

	updateFacilityInventoryCountDetails(facilityInventoryCountHeaderId){
		return super.update(`${this.base}/update-facility-inventory-count-details/{facilityInventoryCountHeaderId}`, { 
			facilityInventoryCountHeaderId:facilityInventoryCountHeaderId
		});	
    }

	updateNikoFacilityInventoryCountDetails(facilityInventoryCountHeaderId){
		return super.update(`${this.base}/update-niko-facility-inventory-count-details/{facilityInventoryCountHeaderId}`, { 
			facilityInventoryCountHeaderId:facilityInventoryCountHeaderId
		});	
    }

	convert(facilityInventoryCountHeaderId){ 
        return super.update(`${this.base}/convert/{facilityInventoryCountHeaderId}`,{ 
			facilityInventoryCountHeaderId:facilityInventoryCountHeaderId
		});	
    }

	downloadInventoryDetail(filter) {
        return super.find(this.base + '/download-inventory-detail/{?searchQuery,sort,facilityInventoryCountHeaderId}', filter);    
    }
	
	updateQuantity(resource) {
		var url =`${this.base}/{id}/update-quantity`;
		if (resource.quantity !== null) {
			url = url + '?quantity={quantity}';
		}
		return super.batchUpdate(url, resource);	
	}	

	newDownloadInventoryDetail(filter) {
        return super.find(this.base + '/new-download-inventory-detail/{?searchQuery,sort,facilityInventoryCountHeaderId}', filter);    
    }

	downloadInventoryReport(filter) {
        return super.find(this.base + '/download-inventory-detail-report/{?facilityOrderId}', filter);    
    }

	downloadInventoryReportBytes(filter) {
        return super.find(this.base + '/download-inventory-detail-report-bytes{?facilityOrderId}', filter);    
    }

	downloadNikoInventoryReport(filter) {
        return super.find(this.base + '/download-niko-inventory-detail-report/{?facilityOrderId}', filter);    
    }

	downloadNikoInventoryReportBytes(filter) {
        return super.find(this.base + '/download-niko-inventory-detail-report-bytes{?facilityOrderId}', filter);    
    }
}

export default FacilityInventoryCountDetailRouteService;
